module.exports = __webpack_public_path__ + "img/SWP_Axe_1H_04 (1).ce8d5d25.png";